import { com } from '@eidu/web'
import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, Stack, TextField } from '@mui/material'
import React from 'react'
import EntityTypeDisplay from './EntityTypeDisplay'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import FieldType = com.eidu.sharedlib.entity.field.FieldType
import Field = com.eidu.sharedlib.entity.field.Field

const isReference = (fieldType: FieldType) => fieldType === FieldType.Reference

export type FieldDisplayProps = {
  availableEntityTypes: readonly EntityType[]
  field: Field
}

const FieldDisplay = ({ availableEntityTypes, field }: FieldDisplayProps) => {
  // Find entity type names for reference types
  const referenceTypes = field.validReferenceTypes?.asJsReadonlySetView()?.let((it) => Array.from(it)) || []

  const idPrefix = `field-${field.id.toString()}`

  return (
    <>
      <Stack direction="row">
        <TextField
          label={field.name}
          id={`${idPrefix}-display-${field.name}`}
          value={field.type.name}
          InputProps={{ readOnly: true }}
          sx={{ flex: 1 }}
          disabled
        />
        <FormControlLabel
          control={<Checkbox checked={field.required} disabled />}
          label="Required"
          sx={{ paddingLeft: 2, flex: 1 }}
        />
      </Stack>
      {isReference(field.type) && (
        <Stack direction="row" sx={{ marginTop: 3 }}>
          <Box sx={{ flex: 0.1 }} />
          <FormControl disabled sx={{ flex: 0.9 }}>
            <InputLabel id={`${idPrefix}-reftype-${field.name}`}>Valid types for {field.name}</InputLabel>
            <EntityTypeDisplay
              label={`Valid types for ${field.name}`}
              labelId={`${idPrefix}-reftype-${field.name}`}
              availableEntityTypes={availableEntityTypes}
              selectedEntityTypes={referenceTypes}
            />
          </FormControl>
          <FormControlLabel control={<Box />} label="" sx={{ paddingLeft: 2, flex: 1 }} />
        </Stack>
      )}
    </>
  )
}

export default FieldDisplay
